<h2 mat-dialog-title style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span *ngIf="!data.editLane">Add Lane</span>
	<span *ngIf="data.editLane">Update Lane</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content
	*ngIf="!utilService.isNullOrUndefined(data)"
	style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px"
>
	<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
		<div fxFlex>
			<mat-form-field fxFlex="100">
				<input
					#LocationCtrl="ngModel"
					#originInput
					(setAddress)="getAddressOnChange($event,LocationCtrl)"
					[(ngModel)]="origin"
					[disabled]="data.editLane && data.inputConfig && data.inputConfig.origin"
					appGoogleLocation
					matInput
					name="origin"
					placeholder="Origin"
					required
					type="text"
				/>
			</mat-form-field>
		</div>
		<div fxFlex>
			<mat-form-field fxFlex="100">
				<mat-select
					[(ngModel)]="model.trailerType"
					[compareWith]="compareEquipment"
					[disabled]="data.editLane && data.inputConfig && data.inputConfig.trailerType"
					placeholder="Trailer Type"
				>
					<mat-option *ngFor="let trailer of trailerTypes" [value]="trailer.dbVal">
						{{trailer.value}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>

	<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="2rem">
		<app-destinations
			(destinationChanges)="destinations($event)"
			[inputConfig]="data.inputConfig"
			[lane]="data.lane"
			fxFlex="100"
		></app-destinations>
	</div>

	<div #div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem">
		<div fxFlex="40" fxLayoutAlign="space-between center">
			<mat-checkbox
				*ngIf="!data.editLane"
				[(ngModel)]="model.runsReverseLane"
				[color]=" 'primary' "
				[labelPosition]=" 'after' "
			>
				{{data.runsReverseLaneText}}
			</mat-checkbox>
			<mat-checkbox
				[disabled]="data.editLane"
				[(ngModel)]="model.ltl"
				[color]=" 'primary' "
				[labelPosition]=" 'after' "
			>
				Partial
			</mat-checkbox>
		</div>
		<mat-form-field *ngIf="isAdmin" fxFlex="30">
			<input
				[(ngModel)]="model.originDeadheadLimit"
				matInput
				placeholder="Origin Deadhead Limit"
				type="number"
			/>
		</mat-form-field>
		<mat-form-field *ngIf="isAdmin" fxFlex="30">
			<input
				[(ngModel)]="model.destinationDeadheadLimit"
				matInput
				placeholder="Destination Deadhead Limit"
				type="number"
			/>
		</mat-form-field>
	</div>
	<br />
	<mat-divider *ngIf="!data.editLane"></mat-divider>
	<h3 style="font-weight: normal">Lane Frequency</h3>
	<mat-divider></mat-divider>
	<br />
	<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem">
		<mat-checkbox
			[(ngModel)]="model.runDaily"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			fxFlex="20"
			>Run Daily
		</mat-checkbox>
		<mat-form-field fxFlex="15">
			<mat-select [(ngModel)]="model.weeklyFrequency" placeholder="Weekly Frequency">
				<mat-option
					*ngFor="let weeklyFrequencyData of weeklyFrequencyList"
					[value]="weeklyFrequencyData"
				>
					{{weeklyFrequencyData == 11 ? '> 10' : weeklyFrequencyData}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<br />
	<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="2rem">
		<mat-checkbox
			[(ngModel)]="model.monday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Monday
		</mat-checkbox>
		<mat-checkbox
			[(ngModel)]="model.tuesday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Tuesday
		</mat-checkbox>
		<mat-checkbox
			[(ngModel)]="model.wednesday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Wednesday
		</mat-checkbox>
		<mat-checkbox
			[(ngModel)]="model.thursday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Thursday
		</mat-checkbox>
		<mat-checkbox
			[(ngModel)]="model.friday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Friday
		</mat-checkbox>
		<mat-checkbox
			[(ngModel)]="model.saturday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Saturday
		</mat-checkbox>
		<mat-checkbox
			[(ngModel)]="model.sunday"
			[color]=" 'primary' "
			[labelPosition]=" 'after' "
			(ngModelChange)="resetRunDaily()"
		>
			Sunday
		</mat-checkbox>
	</div>
</mat-dialog-content>

<mat-divider></mat-divider>

<mat-dialog-actions
	*ngIf="!utilService.isNullOrUndefined(data)"
	style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px"
>
	<div fxFlex="100" fxLayoutAlign="end end" fxLayoutGap="0.5rem">
		<button (click)="closeDialog()" mat-raised-button>Cancel</button>
		<button
			(click)="!data.editLane ? addNewTruckLane() : updateLane()"
			*ngIf="!isRequestInProgress"
			[disabled]="isFormInvalid()"
			color="primary"
			mat-raised-button
		>
			{{!data.editLane ? 'Add' : 'Update'}}
		</button>
		<mat-spinner *ngIf="isRequestInProgress" [diameter]="30"></mat-spinner>
	</div>
</mat-dialog-actions>
